const getScript = (url, async = true, defer = true) =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.async = async;
    script.defer = defer;
    script.onerror = reject;
    script.onload = script.onreadystatechange = () => {
      const loadState = this.readyState;
      if (loadState && loadState !== 'loaded' && loadState !== 'complete') return;
      script.onload = script.onreadystatechange = null;
      resolve();
    };
    document.head.appendChild(script);
  });

function loadGMapsApi() {
  const maps = document.querySelectorAll('store-locator[data-api-key], store-locator-details[data-api-key]');
  if (maps.length === 0) return;
  const apiKeys = [...new Set([...maps].map((map) => map.getAttribute('data-api-key')))];
  [...apiKeys].forEach((key) => {
    const script = document.querySelector('script[src*="' + key + '&"]');
    if (script) return;
    getScript(`https://maps.googleapis.com/maps/api/js?key=${key}&libraries=geometry,places,marker&callback=loadGmap`).catch(() => {
      console.debug('Could not load script');
    });
  });
}
document.addEventListener('DOMContentLoaded', loadGMapsApi);
function loadGmap() {
  publish(PUB_SUB_EVENTS.mapsApiLoad, undefined);
}

const PUB_SUB_EVENTS = {
    mapsApiLoad: 'maps-api-load',
  };

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

subscribe(PUB_SUB_EVENTS.mapsApiLoad, () => {
  if (!customElements.get('store-locator-details')) {
    class StoreLocatorDetails extends HTMLElement {
      constructor() {
        super();
        this.latitude = parseFloat(this.getAttribute('data-latitude'));
        this.longitude = parseFloat(this.getAttribute('data-longitude'));
        this.storeType = this.getAttribute('data-storetype');
        this.mapStyle = this.getAttribute('data-map-styles') && JSON.parse(this.getAttribute('data-map-styles'));
        this.mapZoom = parseInt(this.getAttribute('data-zoom'));
        this.isInStorePickup = this.getAttribute('data-is-in-store-pickup');
      }
      connectedCallback() {
        this.innerHTML = `<div id="store-map"></div>`;
        this.initMap();
      }

      initMap() {
        const myLatLng = { lat: this.latitude, lng: this.longitude };
        const map = new google.maps.Map(this.querySelector('#store-map'), {
          zoom: this.mapZoom,
          center: myLatLng,
          disableDefaultUI: true,
          zoomControl: true,
          styles: this.mapStyle ?? [],
        });

        if (!!window?.storeLocatorStrings?.pins[this.isInStorePickup?'instore':'standard']) {
          const marker = new google.maps.Marker({
            position: myLatLng,
            map: map,
            icon: {
              url: window.storeLocatorStrings.pins[this.isInStorePickup?'instore':'standard'],
              scaledSize: new google.maps.Size(46, 58),
            },
          });
        } else {
          const marker = new google.maps.Marker({
            position: myLatLng,
            map: map,
          });
        }
      }
    }
    customElements.define('store-locator-details', StoreLocatorDetails);
  }
});
